import React from "react";
import "./postCardHorizontal.scss";
import parse from "html-react-parser";
import { Link } from "gatsby";
import Image from "gatsby-image";
import FallBackImg from "../FallBackImg/fallBackImg";
import { getBlogPostUri } from "../../utils/buzzHelper";

const PostCardHorizontal = ({
  post,
  showDescription,
  customClass,
}) => {
  const featuredImage = post.featuredImage
    ? {
        fluid:
          post.featuredImage?.node?.localFile
            ?.childImageSharp?.fluid,
        alt: post.featuredImage?.node?.alt || "",
      }
    : null;

  return (
    <Link to={getBlogPostUri(post)} itemProp="url">
      <article
        itemScope
        itemType="http://schema.org/Article"
      >
        <div
          className={`post-card-horizontal ${
            customClass ? customClass : ""
          }`}
        >
          <div className="title-wrap">
            <h2 className="title">
              <span itemProp="headline">
                {parse(post.title || " ")}
              </span>
            </h2>
            {showDescription ? (
              <section
                itemProp="description"
                className="description"
              >
                {parse(post.excerpt || " ")}
              </section>
            ) : (
              ""
            )}
            <div className="info-wrap">
              <div className="info categories-wrap">
                {post.categories?.nodes.map(
                  (item, index) => (
                    <Link
                      to={item.uri}
                      itemProp="url"
                      key={index}
                    >
                      {item.name}
                    </Link>
                  )
                )}
              </div>
              <div className="info date-wrap">
                {post.date}
              </div>
              <div className="info read-time-wrap">
                {post.seo.readingTime} min read
              </div>
            </div>
          </div>
          {featuredImage ? (
            <Image
              fluid={featuredImage.fluid}
              alt={featuredImage.alt}
            />
          ) : (
            <div className="gatsby-image-wrapper">
              <FallBackImg />
            </div>
          )}
        </div>
      </article>
    </Link>
  );
};

export default PostCardHorizontal;
